/* eslint-disable complexity */
/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import React from 'react';
import ReactDOM from 'react-dom';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import {
    Box, Divider, Icon, Link, Text
} from 'components/ui';
import { breakpoints, forms } from 'style/config';
import CheckoutCreditCardForm from 'components/RwdCheckout/Sections/Payment/CheckoutCreditCardForm';
import Radio from 'components/Inputs/Radio/Radio';
import PaymentDisplay from 'components/RwdCheckout/Sections/Payment/Display';
import CVCInfoModal from 'components/RwdCheckout/Sections/Payment/Section/CVCInfoModal';
import PaymentSectionFooter from 'components/RwdCheckout/Sections/Payment/Section/PaymentSectionFooter';
import CreditCardsList from 'components/RwdCheckout/Sections/Payment/Section/CreditCardsList';
import PaypalRadio from 'components/RwdCheckout/Sections/Payment/Section/PaypalRadio';
import PaymentLogo from 'components/RwdCheckout/PaymentLogo/PaymentLogo';
import OrderUtils from 'utils/Order';
import FormsUtils from 'utils/Forms';
import basketUtils from 'utils/Basket';
import agentAwareUtils from 'utils/AgentAware';
import IconCross from 'components/LegacyIcon/IconCross';
import userUtils from 'utils/User';
import creditCardUtils from 'utils/CreditCard';
import ErrorMsg from 'components/ErrorMsg';
import KlarnaRadio from 'components/RwdCheckout/Sections/Payment/Section/KlarnaRadio';
import KlarnaPaymentMethod from 'components/Klarna/KlarnaPaymentMethod';
import AfterpayRadio from 'components/RwdCheckout/Sections/Payment/Section/AfterpayRadio';
import AfterpayPaymentMethod from 'components/Afterpay/AfterpayPaymentMethod';
import PazeRadio from 'components/RwdCheckout/Sections/Payment/Section/PazeRadio';
import PazePaymentMethod from 'components/Paze/PazePaymentMethod';
import VenmoRadio from 'components/RwdCheckout/Sections/Payment/Section/VenmoRadio';
import VenmoPaymentMethod from 'components/Venmo/VenmoPaymentMethod';
import store from 'store/Store';
import ApplePay from 'services/ApplePay';
import utilityApi from 'services/api/utility';
import PayPal from 'utils/PayPal';
import PayPalCheckout from 'utils/PayPalCheckout';
import checkoutApi from 'services/api/checkout';
import OrderActions from 'actions/OrderActions';
import { setReady as paypalSetReady } from 'actions/PayPalActions';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import Storage from 'utils/localStorage/Storage';
import checkoutUtils from 'utils/Checkout';
import Debounce from 'utils/Debounce';
import anaConsts from 'analytics/constants';
import analyticsUtils from 'analytics/utils';
import processEvent from 'analytics/processEvent';
import Location from 'utils/Location';
import checkoutBindings from 'analytics/bindings/pages/checkout/checkoutBindings';
import deepExtend from 'utils/deepExtend';
import pazeUtils from 'utils/Paze';
import { DebouncedResize } from 'constants/events';
import Venmo from 'utils/Venmo';
import localeUtils from 'utils/LanguageLocale';

const CARD_IMG_SIZE = 32;

const PAYMENT_FLAGS = {
    isPayWithPayPal: 'isPayWithPayPal',
    isPayWithApplePay: 'isPayWithApplePay',
    isPayWithKlarna: OrderUtils.PAYMENT_GROUP_TYPE.KLARNA,
    isPayWithAfterpay: OrderUtils.PAYMENT_GROUP_TYPE.AFTERPAY,
    isPayWithPaze: OrderUtils.PAYMENT_GROUP_TYPE.PAZE,
    isPayWithVenmo: OrderUtils.PAYMENT_GROUP_TYPE.VENMO,
    isNewUserPayWithCreditCard: 'isNewUserPayWithCreditCard'
};

const maxCreditCards = Sephora.configurationSettings.maxCreditCards;

class PaymentSectionExistingUser extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            creditCardsToDisplay: 3,
            openCVCModal: false,
            isPayWithPayPal: this.props.isPayPalSelected,
            shouldShowPaze: false,
            openCreditCardForm: false,
            isApplePayEnabled: false,
            isApplePayFlow: false
        };
    }

    checkIsMobile = () => {
        this.setState({
            isMobile: window.matchMedia(breakpoints.smMax).matches
        });
    };

    componentDidMount() {
        if (this.props.creditCardPaymentGroup) {
            this.setNewCreditCard(this.props.creditCardPaymentGroup);
        }

        const editSectionName = FormsUtils.FORMS.CHECKOUT.BILLING_COUNTRIES_LIST;

        if (store.getState().editData[editSectionName]) {
            this.setState({ billingCountries: store.getState().editData[editSectionName] });
        } else {
            utilityApi.getCountryList().then(billingCountries => {
                this.setState({ billingCountries: billingCountries });
                this.props.updateEditDataAction(billingCountries, editSectionName);
            });
        }

        if (this.props.isPayPalEnabled && this.props.priceInfo) {
            PayPal.preparePaypalCheckout();
        }

        if (Sephora.configurationSettings.isVenmoEnabled) {
            Venmo.prepareVenmoCheckout();
        }

        const isSephoraCardEdit = Storage.session.getItem(LOCAL_STORAGE.EDIT_SEPHORA_CARD);

        if (isSephoraCardEdit) {
            const { creditCardOptions = [] } = this.props;
            const sephoraCreditCard = creditCardOptions.find(payment => OrderUtils.isSephoraCardType(payment));

            if (sephoraCreditCard) {
                this.setNewCreditCard(sephoraCreditCard);
                Storage.session.setItem(LOCAL_STORAGE.EDIT_SEPHORA_CARD, false);
            }
        }

        this.setPazeVisible();
        this.checkIsMobile();
        window.addEventListener(DebouncedResize, this.checkIsMobile);
    }

    componentWillUnmount() {
        window.removeEventListener(DebouncedResize, this.checkIsMobile);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.isApplePayFlow !== prevState.isApplePayFlow) {
            return { isApplePayFlow: nextProps.isApplePayFlow };
        }

        return null;
    }

    componentDidUpdate(prevProps) {
        ApplePay.getApplePaymentType(this.props.orderDetails).then(applePayType => {
            const isApplePayEnabled = applePayType !== ApplePay.TYPES.HIDDEN;

            if (this.state.isApplePayEnabled !== isApplePayEnabled) {
                this.setState({ isApplePayEnabled });
            }
        });

        if (prevProps.klarnaError !== this.props.klarnaError && this.props.klarnaError.error && this.props.klarnaError.error.errorMessage) {
            this.setState({ isPayWithPayPal: this.props.isPayPalSelected });
        }

        const { creditCardPaymentGroup } = this.props;
        const noCreditCardPayment = creditCardPaymentGroup !== prevProps.creditCardPaymentGroup && !creditCardPaymentGroup;
        const noPayment = this.props.paymentName !== prevProps.paymentName && this.props.paymentName;

        if (noCreditCardPayment || noPayment) {
            //needed for if a user adds a giftCard that covers entire order.
            //this way there is no selected credit card if no credit card is needed
            this.newCreditCard = {};
            this.setState({
                selectedCreditCardId: null,
                securityCode: ''
            });
        }

        const creditCardPayment = creditCardPaymentGroup !== prevProps.creditCardPaymentGroup && creditCardPaymentGroup;

        if (creditCardPayment && !this.state.isPayWithApplePay) {
            /*Update selected CC if:
            (A) User removes gift card and now requires a credit card for order.
                If credit card already in order, use that.
            (B) if user changes CC data of selectedCreditCardId */

            if (!this.state.selectedCreditCardId || this.state.selectedCreditCardId === creditCardPaymentGroup.creditCardId) {
                this.setNewCreditCard(creditCardPaymentGroup, this.props.defaultPayment);
            }
        }
    }

    handleShowMoreOnClick = Debounce.preventDoubleClick(() => {
        let newDisplayNum = this.state.creditCardsToDisplay + 3;

        if (newDisplayNum > this.props.creditCardOptions.length) {
            newDisplayNum = this.props.creditCardOptions.length;
        }

        this.setState({ creditCardsToDisplay: newDisplayNum }, () => {
            const refObj = this.creditCardsList ? this.creditCardsList.refs : {};
            const refKeys = Object.keys(refObj);
            const element = ReactDOM.findDOMNode(refObj[refKeys[refKeys.length - 1]]);
            element &&
                element.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                });
        });
    });

    handleShowLessOnClick = Debounce.preventDoubleClick(() => {
        //after user clicks show less link,
        //return user to display of paypal, apple pay(if avail) and 3 CC
        this.setState({ creditCardsToDisplay: 3 }, () => {
            const refObj = this.creditCardsList ? this.creditCardsList.refs : {};
            const refKeys = Object.keys(refObj);
            const element = ReactDOM.findDOMNode(this.refs.paypal || refObj[refKeys[0]]);
            element &&
                element.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                });
        });
    });

    processPaymentClickEvent = (actionInfo, paymentName) => {
        const eventData = {
            eventStrings: [anaConsts.Event.EVENT_71],
            linkName: 'D=c55',
            actionInfo: actionInfo
        };

        const mostRecentAsyncLoadEvent = analyticsUtils.getMostRecentEvent('asyncPageLoad');

        if (mostRecentAsyncLoadEvent) {
            eventData.previousPage = mostRecentAsyncLoadEvent.eventInfo.attributes.previousPageName;
        }

        checkoutBindings.sotPaymentOptionCheckout(paymentName);
        // Analytics - ILLUPH-98437
        processEvent.process(anaConsts.LINK_TRACKING_EVENT, { data: eventData });
    };

    // TODO PAYPAL: This method is LEGACY FLOW ONLY (immediate popup). Remove after new toggle-select flow is served to 100% of users
    openPayPalPopup = () => {
        PayPal.showPayPal(payload => {
            this.props.withInterstice(payload).then(() => {
                const { sectionSaveOrderAction } = this.props;

                // Mark PayPal as ready and selected after popup completes
                store.dispatch(paypalSetReady(true));
                this.switchPaymentState(PAYMENT_FLAGS.isPayWithPayPal);

                sectionSaveOrderAction(Location.getLocation().pathname, this);

                // Update order details to sync state and enable Place Order button
                checkoutApi.getOrderDetails(OrderUtils.getOrderId()).then(order => {
                    store.dispatch(OrderActions.updateOrder(order));
                    checkoutUtils.disablePlaceOrderButtonBasedOnCheckoutCompleteness();
                });
            });
        });
    };

    selectPayPalWithoutPopup = () => {
        this.switchPaymentState(PAYMENT_FLAGS.isPayWithPayPal);
    };

    handlePayWithPayPalOnClick = Debounce.preventDoubleClick(isEdit => {
        if (OrderUtils.containsRestrictedItem()) {
            this.showError(this.props.paypalRestrictedItemError);

            return;
        }

        const useNewTogglePattern = PayPal.isPayPalCheckoutEnabledForLocale();

        if (useNewTogglePattern) {
            // NEW: When flags are TRUE, use toggle pattern (just select, don't open popup)
            this.selectPayPalWithoutPopup();
            PayPalCheckout.initializePayPalPaymentGroup();
        } else {
            // TODO PAYPAL: Remove this LEGACY FLOW block after new toggle-select flow is served to 100% of users
            // LEGACY: When flags are FALSE, keep old behavior (open popup immediately)
            if (!this.props.paypalOption || isEdit) {
                this.openPayPalPopup();
            } else {
                this.selectPayPalWithoutPopup();
            }
        }

        this.processPaymentClickEvent('checkout:payment:paypal', anaConsts.ACTION_INFO.VENDOR_PAYPAL);
    });

    handlePayWithApplePayClick = Debounce.preventDoubleClick(() => {
        this.switchPaymentState(PAYMENT_FLAGS.isPayWithApplePay);
        this.props.swapPaypalToCreditCard();

        if (checkoutUtils.isGuestOrder()) {
            ApplePay.enableGuestCheckout();
        }

        this.processPaymentClickEvent('checkout:payment:applepay', anaConsts.ACTION_INFO.VENDOR_APPLEPAY);
    });

    handlePaymentClick = paymentType =>
        Debounce.preventDoubleClick(() => {
            this.switchPaymentState(paymentType);
            const paymentName = OrderUtils.getPaymentNameByType(paymentType);
            this.processPaymentClickEvent(`checkout:payment:${paymentName}`, paymentName);
        });

    switchPaymentState = selectedPayment => {
        const newState = { selectedCreditCardId: null };
        Object.keys(PAYMENT_FLAGS).forEach(x => (newState[x] = selectedPayment === PAYMENT_FLAGS[x]));
        this.setState(newState, () => this.updatePayment(selectedPayment));

        processEvent.process(anaConsts.ADD_PAYMENTINFO_EVENT, {
            data: {
                paymentType: selectedPayment
            }
        });
    };

    updatePayment = selectedPayment => {
        const { updatePaymentActions, commonOrderToggleActions } = this.props;

        commonOrderToggleActions({
            isApplePayFlow: selectedPayment === PAYMENT_FLAGS.isPayWithApplePay,
            klarna: selectedPayment === PAYMENT_FLAGS.isPayWithKlarna,
            afterpay: selectedPayment === PAYMENT_FLAGS.isPayWithAfterpay,
            venmo: selectedPayment === PAYMENT_FLAGS.isPayWithVenmo,
            paypal: selectedPayment === PAYMENT_FLAGS.isPayWithPayPal,
            paze: selectedPayment === PAYMENT_FLAGS.isPayWithPaze
        });

        updatePaymentActions(selectedPayment === PAYMENT_FLAGS.isPayWithPaze, selectedPayment === PAYMENT_FLAGS.isPayWithApplePay);
    };

    updateSecurityCode = securityCode => {
        this.setState({ securityCode: securityCode });
    };

    setNewCreditCard = (creditCardData, defaultPayment) => {
        const { commonOrderToggleActions, setNewCardActions } = this.props;

        const creditCardIsDefaultPayment = !defaultPayment || defaultPayment === 'creditCard';
        this.newCreditCard = {
            creditCard: creditCardUtils.cleanCreditCardData(creditCardData),
            isMarkAsDefault: creditCardIsDefaultPayment && creditCardData.isDefault
        };

        commonOrderToggleActions();
        setNewCardActions();

        this.setState({
            selectedCreditCardId: creditCardData.creditCardId,
            isPayWithPayPal: false,
            isPayWithApplePay: false,
            securityCode: ''
        });
    };

    whatShipAddressAsBilling = shippingAddress => {
        // This function is needed for scenarios when user has selected
        // FEDEX shipping address i.e.: addressType === 'HAL'
        // we need to tell the state here to take the credit card form info
        // the user entered.

        return (shippingAddress || false) && shippingAddress?.addressType !== OrderUtils.SHIPPING_METHOD_TYPES.HAL;
    };

    showAddCreditCardForm = e => {
        e.preventDefault();
        const { removeAddress, maxCreditCardsMessage, continueButton, showAddCrediCardActions } = this.props;

        if (this.props.creditCardOptions && this.props.creditCardOptions.length === maxCreditCards) {
            //variable declaration here for clarity
            const title = removeAddress;
            const message = maxCreditCardsMessage;
            const confirmButtonText = continueButton;

            this.props.actionModal(title, message, confirmButtonText);
        } else {
            showAddCrediCardActions();
            this.setState(
                {
                    openCreditCardForm: true,
                    isUseShipAddressAsBilling: this.whatShipAddressAsBilling(this.props.shippingAddress)
                },
                () => {
                    //Analytics
                    const pageDetailPrefix = this.props.isPhysicalGiftCardOnly ? 'gift card ' : '';
                    checkoutBindings.processAsyncPageLoad(pageDetailPrefix + 'payment-add credit card');
                }
            );
        }
    };

    showEditCreditCardForm = prevCreditCardInfo => {
        const creditCardInfo = deepExtend({}, prevCreditCardInfo);

        //format exp month for edit credit card
        if (creditCardInfo.expirationMonth.length === 1) {
            creditCardInfo.expirationMonth = creditCardUtils.formatExpMonth(creditCardInfo.expirationMonth);
        }

        //format exp year for edit credit card
        if (creditCardInfo.expirationYear.length === 4) {
            creditCardInfo.expirationYear = creditCardUtils.formatExpYear(creditCardInfo.expirationYear);
        }

        this.setState(
            {
                openCreditCardForm: true,
                editCreditCard: creditCardInfo,
                isUseShipAddressAsBilling: creditCardUtils.isShipAddressBillingAddress(this.props.shippingAddress, creditCardInfo.address)
            },
            () => {
                //Analytics
                const pageDetailPrefix = this.props.isPhysicalGiftCardOnly ? 'gift card ' : '';
                checkoutBindings.processAsyncPageLoad(pageDetailPrefix + 'payment-edit credit card');
            }
        );
    };

    closeCreditCardForm = () => {
        this.setState({
            openCreditCardForm: false,
            editCreditCard: null
        });
    };

    showError = message => {
        this.setState({ errorMessage: message });
    };

    renderPazePaymentMethod = () => {
        const defaultPayment = this.props.defaultPayment;
        const isPazeEnabledForThisOrder = this.props.isPazeEnabledForThisOrder;

        return (
            <PazeRadio
                defaultPayment={defaultPayment}
                disabled={!isPazeEnabledForThisOrder}
                onClick={this.handlePaymentClick(OrderUtils.PAYMENT_GROUP_TYPE.PAZE)}
            >
                <PazePaymentMethod />
            </PazeRadio>
        );
    };

    renderVenmoPaymentMethod = () => {
        const { isGiftCardShow, defaultPayment, isVenmoEnabledForThisOrder } = this.props;

        return (
            localeUtils.isUS() && (
                <VenmoRadio
                    defaultPayment={defaultPayment}
                    disabled={!isVenmoEnabledForThisOrder}
                    onClick={this.handlePaymentClick(OrderUtils.PAYMENT_GROUP_TYPE.VENMO)}
                >
                    <VenmoPaymentMethod isGiftCardShow={isGiftCardShow} />
                </VenmoRadio>
            )
        );
    };

    // Set Paze visibility based on configuration flags and user eligibility
    setPazeVisible = async () => {
        const shouldShowPaze = pazeUtils.isPazeVisible();

        // If Paze is set to be dynamic, we only show it to users that are eligible
        if (Sephora.configurationSettings.isPazeDynamic && shouldShowPaze) {
            const canCheckoutPaze = Storage.local.getItem(LOCAL_STORAGE.CAN_CHECKOUT_PAZE);
            this.setState({
                shouldShowPaze: canCheckoutPaze
            });
        } else {
            this.setState({
                shouldShowPaze: shouldShowPaze
            });
        }
    };

    handleShowMoreOrLessOnClick = () => {
        const { creditCardOptions } = this.props;
        const { creditCardsToDisplay } = this.state;
        creditCardsToDisplay < creditCardOptions.length ? this.handleShowMoreOnClick() : this.handleShowLessOnClick();
    };

    render() {
        const {
            isZeroCheckout,
            shippingAddress,
            creditCardOptions = [],
            defaultPayment,
            paypalOption,
            isBopis,
            isSddOrder,
            creditCardPaymentGroup,
            isPayPalEnabled,
            isKlarnaEnabledForThisOrder,
            isAfterpayEnabledForThisOrder,
            isAfterpayEnabledForThisProfile,
            paymentName,
            hasAutoReplenishItemInBasket,
            orderDetails,
            showMoreCards,
            showLessCards,
            debitCardDisclaimer,
            addNewCreditCard,
            isGiftCardShow
        } = this.props;

        const {
            selectedCreditCardId,
            creditCardsToDisplay,
            editCreditCard,
            isUseShipAddressAsBilling,
            isPayWithPayPal,
            errorMessage,
            isApplePayFlow,
            isApplePayEnabled,
            isPayWithApplePay,
            openCreditCardForm,
            billingCountries,
            securityCode,
            securityCodeInvalid
        } = this.state;

        const { isKlarnaPaymentEnabled, afterpayEnabled: isAfterpayPaymentEnabled, isVenmoEnabled } = Sephora.configurationSettings;

        const newCreditCard = {
            firstName: userUtils.getProfileFirstName(),
            lastName: userUtils.getProfileLastName(),
            address: {
                country: userUtils.getShippingCountry().countryCode
            }
        };

        const isKlarnaSelected = paymentName === 'payWithKlarna';
        const isAfterpaySelected = paymentName === 'payWithAfterpay';
        const isPazeSelected = paymentName === 'payWithPaze';
        const isVenmoSelected = paymentName === 'payWithVenmo';
        const displayedCreditCards = creditCardOptions.slice(0, creditCardsToDisplay);
        const numberOfSavedCreditCards = creditCardUtils.numberOfSavedCards(creditCardOptions);
        const giftCardIsApplied = !!orderDetails?.priceInfo?.giftCardAmount;
        const giftcardAmount = Number(basketUtils.removeCurrency(orderDetails?.priceInfo?.giftCardAmount));
        const orderTotal = Number(basketUtils.removeCurrency(orderDetails?.priceInfo?.orderTotal));
        const creditCardRequiredMessage =
            orderDetails?.paymentGroups?.paymentMessages?.[0] && orderDetails?.paymentGroups?.paymentMessages?.[0].messages?.[0];
        const hasSDUInBasket = OrderUtils.hasSDUInBasket(orderDetails);
        const shouldDisplayAutoReplenMessage = creditCardRequiredMessage && hasAutoReplenishItemInBasket && !openCreditCardForm;
        const shouldDisplaySDUMessage = creditCardRequiredMessage && hasSDUInBasket && !openCreditCardForm;
        const shouldDisplaySDUMessageRed = shouldDisplaySDUMessage && giftCardIsApplied && giftcardAmount >= orderTotal;
        const shouldDisplayAlternatePaymentMethods = !openCreditCardForm && !isZeroCheckout;
        const shouldDisplayAddOrDeleteCreditCardButton = !isZeroCheckout || hasSDUInBasket || hasAutoReplenishItemInBasket;
        const isPayPalPayLaterEligible = orderDetails?.items?.isPayPalPayLaterEligible;

        return (
            <div>
                <div>
                    {errorMessage && <ErrorMsg children={errorMessage} />}
                    {(shouldDisplaySDUMessage || shouldDisplayAutoReplenMessage) && (
                        <ErrorMsg
                            backgroundColor='nearWhite'
                            color={shouldDisplaySDUMessageRed || shouldDisplayAutoReplenMessage ? 'red' : 'black'}
                            padding={3}
                            borderRadius={2}
                            display='flex'
                        >
                            {(shouldDisplaySDUMessageRed || shouldDisplayAutoReplenMessage) && (
                                <Icon
                                    name='alert'
                                    size='1.25em'
                                    marginRight='.5em'
                                />
                            )}
                            <span>{creditCardRequiredMessage}</span>
                        </ErrorMsg>
                    )}
                    <fieldset>
                        {shouldDisplayAlternatePaymentMethods && (
                            <div>
                                {(isPayPalEnabled || hasAutoReplenishItemInBasket) && (
                                    <PaypalRadio
                                        ref={'paypal'}
                                        isZeroCheckout={isZeroCheckout}
                                        isPayWithPayPal={isPayWithPayPal}
                                        paypalOption={paypalOption}
                                        handlePayWithPayPalOnClick={this.handlePayWithPayPalOnClick}
                                        hasAutoReplenishItemInBasket={hasAutoReplenishItemInBasket}
                                        isPayPalPayLaterEligible={isPayPalPayLaterEligible}
                                        fieldsetName='paymentMethodGroup'
                                    />
                                )}
                                {isVenmoEnabled && this.renderVenmoPaymentMethod()}
                                {isKlarnaPaymentEnabled && (
                                    <KlarnaRadio
                                        defaultPayment={defaultPayment}
                                        disabled={!isKlarnaEnabledForThisOrder}
                                        fieldsetName='paymentMethodGroup'
                                        onClick={this.handlePaymentClick(OrderUtils.PAYMENT_GROUP_TYPE.KLARNA)}
                                    >
                                        <KlarnaPaymentMethod />
                                    </KlarnaRadio>
                                )}
                                {isAfterpayPaymentEnabled && isAfterpayEnabledForThisProfile && (
                                    <AfterpayRadio
                                        defaultPayment={defaultPayment}
                                        disabled={!isAfterpayEnabledForThisOrder}
                                        fieldsetName='paymentMethodGroup'
                                        onClick={this.handlePaymentClick(OrderUtils.PAYMENT_GROUP_TYPE.AFTERPAY)}
                                    >
                                        <AfterpayPaymentMethod />
                                    </AfterpayRadio>
                                )}
                                {isApplePayEnabled && (
                                    <div>
                                        <Radio
                                            paddingY={3}
                                            dotOffset={0}
                                            alignItems='center'
                                            name='payWithApplePay'
                                            checked={isPayWithApplePay}
                                            disabled={this.state.isMobile && hasAutoReplenishItemInBasket}
                                            onClick={this.handlePayWithApplePayClick}
                                        >
                                            <PaymentDisplay
                                                isBopis={isBopis}
                                                isGiftCardShow={isGiftCardShow}
                                                isSddOrder={isSddOrder}
                                                isApplePay={true}
                                                hasAutoReplenishItemInBasket={hasAutoReplenishItemInBasket}
                                            />
                                        </Radio>
                                        <Divider marginY={[3, null]} />
                                    </div>
                                )}
                                {this.state.shouldShowPaze && this.renderPazePaymentMethod()}
                            </div>
                        )}
                    </fieldset>
                    <div>
                        {openCreditCardForm ? (
                            <Box
                                id='creditcard_form'
                                marginTop={4}
                            >
                                <CheckoutCreditCardForm
                                    editStore={FormsUtils.getStoreEditSectionName(FormsUtils.FORMS.CHECKOUT.CREDIT_CARD)}
                                    creditCard={editCreditCard || newCreditCard}
                                    defaultPayment={defaultPayment}
                                    cardType={editCreditCard && OrderUtils.getThirdPartyCreditCard(editCreditCard)}
                                    shippingAddress={shippingAddress}
                                    isUseShippingAddressAsBilling={isUseShipAddressAsBilling}
                                    isDefault={editCreditCard ? editCreditCard.isDefault : false}
                                    cancelCallback={this.closeCreditCardForm}
                                    billingCountries={billingCountries}
                                    isEditMode={!!editCreditCard}
                                    isFirstCreditCard={editCreditCard ? numberOfSavedCreditCards === 1 : numberOfSavedCreditCards === 0}
                                    isBopis={isBopis}
                                />
                            </Box>
                        ) : (
                            <div data-at={Sephora.debug.dataAt('credit_cards_area')}>
                                <CreditCardsList
                                    defaultPayment={defaultPayment}
                                    cards={displayedCreditCards}
                                    securityCode={securityCode}
                                    securityCodeInvalid={securityCodeInvalid}
                                    selectedCreditCardId={selectedCreditCardId}
                                    creditCardPaymentGroup={creditCardPaymentGroup}
                                    creditCardOptions={creditCardOptions}
                                    setNewCreditCard={this.setNewCreditCard}
                                    showEditCreditCardForm={this.showEditCreditCardForm}
                                    updateSecurityCode={this.updateSecurityCode}
                                    isBopis={isBopis}
                                    isZeroCheckout={isZeroCheckout}
                                    shouldDisplayAddOrDeleteCreditCardButton={shouldDisplayAddOrDeleteCreditCardButton}
                                    onRef={comp => (this.creditCardsList = comp)}
                                />

                                {shouldDisplayAddOrDeleteCreditCardButton && (
                                    <React.Fragment>
                                        <Link
                                            hoverSelector='strong'
                                            display='flex'
                                            alignItems='center'
                                            aria-controls='creditcard_form'
                                            padding={4}
                                            marginX={-4}
                                            data-at={Sephora.debug.dataAt('add_new_credit_card')}
                                            onClick={this.showAddCreditCardForm}
                                            className={agentAwareUtils.applyHideAgentAwareClassToTiers(['1', '2'])}
                                        >
                                            <IconCross fontSize={forms.RADIO_SIZE} />
                                            <Box
                                                aria-hidden
                                                fontSize={CARD_IMG_SIZE}
                                                marginLeft={forms.RADIO_MARGIN + 'px'}
                                                marginRight={4}
                                            >
                                                <PaymentLogo />
                                            </Box>
                                            <div>
                                                <strong>{addNewCreditCard}</strong>
                                                {this.props.isCanada && (
                                                    <Text
                                                        display='block'
                                                        fontSize='sm'
                                                        color='gray'
                                                    >
                                                        {debitCardDisclaimer}
                                                    </Text>
                                                )}
                                            </div>
                                        </Link>
                                    </React.Fragment>
                                )}
                                {creditCardOptions.length > 3 && (
                                    <>
                                        <Divider marginY={4} />
                                        <Link
                                            color='blue'
                                            paddingY={2}
                                            marginY={-2}
                                            data-at={Sephora.debug.dataAt('show_more_cards')}
                                            marginLeft={forms.RADIO_SIZE + forms.RADIO_MARGIN + 'px'}
                                            onClick={this.handleShowMoreOrLessOnClick}
                                        >
                                            {creditCardsToDisplay < creditCardOptions.length ? showMoreCards : showLessCards}
                                        </Link>
                                    </>
                                )}
                                <PaymentSectionFooter
                                    creditCardOptions={creditCardOptions}
                                    isBopis={isBopis}
                                    isSddOrder={isSddOrder}
                                    isApplePayFlow={isApplePayFlow}
                                    isKlarnaFlow={isKlarnaSelected}
                                    isAfterpayFlow={isAfterpaySelected}
                                    isPazeFlow={isPazeSelected}
                                    isVenmoFlow={isVenmoSelected}
                                    isPayWithPayPal={isPayWithPayPal}
                                    selectedCreditCardId={selectedCreditCardId}
                                    securityCode={securityCode}
                                    newCreditCard={this.newCreditCard}
                                    parentToValidate={this}
                                    hasSDUInBasket={hasSDUInBasket}
                                    showEditCreditCardForm={this.showEditCreditCardForm}
                                    {...this.props}
                                />
                            </div>
                        )}
                    </div>
                </div>

                <CVCInfoModal />
            </div>
        );
    }
}

export default wrapComponent(PaymentSectionExistingUser, 'PaymentSectionExistingUser');
